<template>
  <div class="key-con">
    <div class="keyboardContainer" :class="[keyboardType]">
      <!-- <div class="key-setting">Keyboard Settings</div> -->
      <div class="simple-keyboard-main" ref="simpleKeyboardMainDom"></div>
    </div>
    <div class="gesture" v-show="showGesture">
      <div
        class="left_gesture"
        :style="{
          backgroundImage: `url(${leftGestureDa})`,
          opacity: 0.5,
        }"
      ></div>
      <div
        class="right_gesture"
        :class="{
          right_top_row: rightGestureKey.includes('right-top-row'),
          right_bottom_row: rightGestureKey.includes('right-bottom-row'),
          special_right: specialRightGestures.includes(nextInput),
        }"
        :style="{
          backgroundImage: `url(${rightGestureDa})`,
          opacity: 0.5,
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import {
  gestureObjV2,
  rightGesture,
  leftGesture,
  multiGesture,
  specialRightGestures,
} from "./gestureRow.js";
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";

export default {
  name: "SimpleKeyboard",
  props: {
    keyboardClass: {
      default: "simple-keyboard-main",
      type: String,
    },
    // 当前输入的字符串
    input: {
      type: String,
    },
    // 下一个输入的字符
    nextInput: {
      type: String,
    },
    showGesture: {
      type: Boolean,
      default: true,
    },
    rightColor: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    gestureObjV2,
    leftGesture,
    rightGesture,
    multiGesture, // 组合按键
    specialRightGestures, // 特别靠右的按键，需要单独设置style
    rightGestureDa: null,
    leftGestureDa: null,
    leftGestureKey: "",
    rightGestureKey: "",
    keyboard: null,
    keyboardTypeClass: "keyboard-normal",
    showShiftTimmer: null,
    displayShiftOnly: {},
    displayDefault: {},
    capslockON: false,
    compare: () => {
      return true;
    },
    supportsWebp: true, // 默认支持webp
  }),
  watch: {
    input(input) {
      console.log("lx input  changes", input);
      this.keyboard.setInput(input);
    },
    nextInput: {
      handler(val) {
        console.log("nextInput changes", val);
        if (val === "") {
          this.leftGestureDa = require("./assets/images/gesture/left-resting-hand.webp");
          this.rightGestureDa = require("./assets/images/gesture/right-resting-hand.webp");
        } else {
          this.handlerGesture(val);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    keyboardType: {
      get: function () {
        return this.keyboardTypeClass;
      },
    },
  },
  created() {
    // 检测是否支持webp
    this.supportsWebp = this.checkWebpSupport();
    console.log("lx supportsWebp", this.supportsWebp);
  },
  mounted() {
    this.rightGestureDa = require("./assets/images/gesture/right-resting-hand.webp");
    this.leftGestureDa = require("./assets/images/gesture/left-resting-hand.webp");
    this.keyboardTypeClass = "keyboard-mac";
    // debugger
    // if (/macintosh|mac os x/i.test(navigator.userAgent)) {
    // this.keyboardTypeClass = "keyboard-mac";
    // } else {
    //   this.keyboardTypeClass = "keyboard-normal";
    // }
    let charMap = [];
    for (let i = "a".charCodeAt(0); i <= "z".charCodeAt(0); i++) {
      charMap[String.fromCharCode(i)] = String.fromCharCode(
        "A".charCodeAt(0) + i - "a".charCodeAt(0)
      );
    }

    this.displayDefault = {
      ...charMap,
      "-": "<div class='key-group'><div class='up'>_</div><div class='down'>-</div></div>",
      _: "<div class='key-group'><div class='up'>_</div><div class='down'>-</div></div>",

      "=": "<div class='key-group'><div class='up'>+</div><div class='down'>=</div></div>",
      "+": "<div class='key-group'><div class='up'>+</div><div class='down'>=</div></div>",

      0: "<div class='key-group'><div class='up'>)</div><div class='down'>0</div></div>",
      ")": "<div class='key-group'><div class='up'>)</div><div class='down'>0</div></div>",

      9: "<div class='key-group'><div class='up'>(</div><div class='down'>9</div></div>",
      "(": "<div class='key-group'><div class='up'>(</div><div class='down'>9</div></div>",

      8: "<div class='key-group'><div class='up'>*</div><div class='down'>8</div></div>",
      "*": "<div class='key-group'><div class='up'>*</div><div class='down'>8</div></div>",

      7: "<div class='key-group'><div class='up'>&</div><div class='down'>7</div></div>",
      "&": "<div class='key-group'><div class='up'>&</div><div class='down'>7</div></div>",

      6: "<div class='key-group'><div class='up'>^</div><div class='down'>6</div></div>",
      "^": "<div class='key-group'><div class='up'>^</div><div class='down'>6</div></div>",

      5: "<div class='key-group'><div class='up'>%</div><div class='down'>5</div></div>",
      "%": "<div class='key-group'><div class='up'>%</div><div class='down'>5</div></div>",

      4: "<div class='key-group'><div class='up'>$</div><div class='down'>4</div></div>",
      $: "<div class='key-group'><div class='up'>$</div><div class='down'>4</div></div>",

      3: "<div class='key-group'><div class='up'>#</div><div class='down'>3</div></div>",
      "#": "<div class='key-group'><div class='up'>#</div><div class='down'>3</div></div>",

      2: "<div class='key-group'><div class='up'>@</div><div class='down'>2</div></div>",
      "@": "<div class='key-group'><div class='up'>@</div><div class='down'>2</div></div>",

      1: "<div class='key-group'><div class='up'>!</div><div class='down'>1</div></div>",
      "!": "<div class='key-group'><div class='up'>!</div><div class='down'>1</div></div>",

      "`": "<div class='key-group'><div class='up'>~</div><div class='down'>`</div></div>",
      "~": "<div class='key-group'><div class='up'>~</div><div class='down'>`</div></div>",

      "[": "<div class='key-group'><div class='up'>{</div><div class='down'>[</div></div>",
      "{": "<div class='key-group'><div class='up'>{</div><div class='down'>[</div></div>",

      "]": "<div class='key-group'><div class='up'>}</div><div class='down'>]</div></div>",
      "}": "<div class='key-group'><div class='up'>}</div><div class='down'>]</div></div>",

      "\\": "<div class='key-group'><div class='up'>|</div><div class='down'>\\</div></div>",
      "|": "<div class='key-group'><div class='up'>|</div><div class='down'>\\</div></div>",

      ";": "<div class='key-group'><div class='up'>:</div><div class='down'>;</div></div>",
      ":": "<div class='key-group'><div class='up'>:</div><div class='down'>;</div></div>",

      "'": "<div class='key-group'><div class='up'>\"</div><div class='down'>'</div></div>",
      '"': "<div class='key-group'><div class='up'>\"</div><div class='down'>'</div></div>",

      ",": "<div class='key-group'><div class='up'><</div><div class='down'>,</div></div>",
      "<": "<div class='key-group'><div class='up'><</div><div class='down'>,</div></div>",

      ".": "<div class='key-group'><div class='up'>></div><div class='down'>.</div></div>",
      ">": "<div class='key-group'><div class='up'>></div><div class='down'>.</div></div>",

      "/": "<div class='key-group'><div class='up'>?</div><div class='down'>/</div></div>",
      "?": "<div class='key-group'><div class='up'>?</div><div class='down'>/</div></div>",

      "{escape}": "esc ⎋",
      "{tab}": "tab ↹",
      "{backspace}": "delete ⌫",
      "{enter}": "enter ↵",
      "{capslock}": "caps lock⇪",
      "{shiftleft}": "shift ⇧",
      "{shiftright}": "shift ⇧",
      "{controlleft}": "ctrl",
      "{controlright}": "ctrl",
      // "{altleft}": "alt ⌥",
      "{altleft}": "alt",
      "{altright}": "alt",
      "{metaleft}": "cmd",
      "{metaright}": "cmd",
      "{fn}": "fn",
    };
    this.displayShiftOnly = {
      "{escape}": "esc ⎋",
      "{tab}": "tab ↹",
      "{backspace}": "delete ⌫",
      "{enter}": "enter ↵",
      "{capslock}": "caps lock⇪",
      "{shiftleft}": "shift ⇧",
      "{shiftright}": "shift ⇧",
      "{controlleft}": "ctrl",
      "{controlright}": "ctrl",
      // "{altleft}": "alt ⌥",
      "{altleft}": "alt",
      "{altright}": "alt",
      "{metaleft}": "cmd",
      "{metaright}": "cmd",
      "{fn}": "fn",
    };

    let commonKeyboardOptions = {
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      onKeyReleased: this.onKeyReleased,
      onCompare: this.onCompare,
      theme: "simple-keyboard hg-theme-default hg-layout-default",
      physicalKeyboardHighlight: true,
      syncInstanceInputs: true,
      mergeDisplay: true,
      debug: true,
      useMouseEvents: true,
      usePointerEvents: true,
      useTouchEvents: true,
    };
    this.keyboard = new Keyboard(".simple-keyboard-main", {
      ...commonKeyboardOptions,
      layout: {
        default: [
          "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
          "{tab} q w e r t y u i o p [ ] \\",
          "{capslock} a s d f g h j k l ; ' {enter}",
          "{shiftleft} z x c v b n m , . / {shiftright}",
          "{fn} {controlleft} {altleft} {metaleft} {space} {metaright} {altright} {arrowleft} {arrowup} {arrowdown} {arrowright}",
        ],
        shift: [
          "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
          "{tab} Q W E R T Y U I O P { } |",
          '{capslock} A S D F G H J K L : " {enter}',
          "{shiftleft} Z X C V B N M < > ? {shiftright}",
          "{fn} {controlleft} {altleft} {metaleft} {space} {metaright} {altright} {arrowleft} {arrowup} {arrowdown} {arrowright}",
        ],
        shiftonly: [
          "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
          "{tab} Q W E R T Y U I O P { } |",
          '{capslock} A S D F G H J K L : " {enter}',
          "{shiftleft} Z X C V B N M < > ? {shiftright}",
          "{fn} {controlleft} {altleft} {metaleft} {space} {metaright} {altright} {arrowleft} {arrowup} {arrowdown} {arrowright}",
        ],
      },
      display: this.displayDefault,
    });
  },
  methods: {
    /**
     * 高亮键盘块values中每一个键的底色为蓝色
     * @param {Array} values
     */
    highlight(values) {
      let notFind = false; // 是否存在未找到的键（用不到了）
      for (let i = 0; i < values.length; i++) {
        let value = values[i];
        if (value === "space") {
          value = "{space}";
        } else if (value === "\\") {
          value = "\\\\";
        } else if (value === '"') {
          value = '\\"';
        } else if (value === "↵") {
          value = "{enter}";
        }
        const querystr = `div[data-skbtn="${value}"]`;
        const div = this.$refs.simpleKeyboardMainDom.querySelector(querystr);
        if (div) {
          if (this.rightColor) {
            div.style.backgroundColor = this.rightColor;
            div.style.color = "#fff";
          } else {
            div.style.backgroundColor = "rgb(159, 180, 206)";
          }
        } else {
          notFind = true;
        }
      }
      return notFind;
    },
    clearHighlight() {
      const divs =
        this.$refs.simpleKeyboardMainDom.querySelectorAll("div[data-skbtn]");
      divs.forEach((div) => {
        // 如果没有错误的样式
        if (div.style && div.style.animationName !== "keyPressWrong") {
          div.removeAttribute("style");
        } else {
          // 如果是组合键中按错的
        }
      });
    },
    /**
     * 处理手势
     */
    handlerGesture(val) {
      console.log("lx handlerGesture capslockON", val, this.capslockON);
      if (!val) {
        return;
      }

      // 获取静止手势图片
      const restingHandLeft = this.getImagePath("left-resting-hand");
      const restingHandRight = this.getImagePath("right-resting-hand");

      if (this.rightGesture.includes(val)) {
        this.leftGestureDa = restingHandLeft;
        const webpName = this.gestureObjV2[val].img;
        this.rightGestureDa = this.getImagePath(webpName);
        this.leftGestureKey = "";
        this.rightGestureKey = webpName;
      } else if (this.leftGesture.includes(val)) {
        this.rightGestureDa = restingHandRight;
        const webpName = this.gestureObjV2[val].img;
        this.leftGestureDa = this.getImagePath(webpName);
        this.rightGestureKey = "";
        this.leftGestureKey = webpName;
      } else if (this.multiGesture.includes(val)) {
        const [left, right] = this.gestureObjV2[val].img;
        this.leftGestureDa = this.getImagePath(left);
        this.rightGestureDa = this.getImagePath(right);
        this.rightGestureKey = right;
        this.leftGestureKey = left;
      } else if (val === " ") {
        const webpName = this.gestureObjV2["space"].img;
        this.leftGestureDa = restingHandLeft;
        this.rightGestureDa = this.getImagePath(webpName);
        this.leftGestureKey = "";
        this.rightGestureKey = webpName;
      }
    },
    /**
     * 这个onchange事件中的input参数从keyboard传递过来
     * 并且传递给父组件
     */
    onChange(input) {
      this.$emit("onChange", input);
    },
    onCompare(btn) {
      return this.compare(btn);
    },
    onKeyPress(button) {
      console.log("onKeyPress", button);
      this.$emit("onKeyPress", button);
      /**
       * If you want to handle the shift and caps lock buttons
       */
      if (button === "{shiftright}" || button === "{shiftleft}") {
        // fix这部分代码会导致键盘的data-skbtn变成大写的
        // this.handleShift("shift");
        // this.showShiftTimmer = setTimeout(() => {
        //   this.handleShift("shiftonly");
        //   this.showShiftTimmer = null;
        // }, 1500);
      } else if (button === "{capslock}") {
        // this.capslockON = true;
        // let currentLayout = this.keyboard.options.layoutName;
        // let shiftToggle = currentLayout !== "default" ? "default" : "shift";
        // this.handleShift(shiftToggle);
      }
    },
    onKeyReleased(button) {
      // console.log("onKeyReleased", button);
      this.$emit("onKeyReleased", button);
      if (
        button === "{shiftright}" ||
        button === "{shiftleft}" ||
        button === "{capslock}"
      ) {
        if (this.showShiftTimmer) {
          clearTimeout(this.showShiftTimmer);
          this.showShiftTimmer = null;
        }
        if (button === "{capslock}") {
          this.capslockON = false;
        }
        // fix capslock 3秒钟
        // if (this.capslockON) {
        //   this.handleShift("shift");
        // } else {
        //   this.handleShift("default");
        // }
      }
    },
    handleShift(layout) {
      // let currentLayout = this.keyboard.options.layoutName;
      // let shiftToggle = currentLayout === "default" ? "shift" : "default";
      console.log("currentLayout", layout);
      // debugger
      if (layout === "shiftonly") {
        this.keyboard.setOptions({
          layoutName: "shiftonly",
          display: this.displayShiftOnly,
        });
      } else {
        this.keyboard.setOptions({
          layoutName: layout,
          display: this.displayDefault,
        });
      }
    },
    /**
     * 检测浏览器是否支持webp
     */
    checkWebpSupport() {
      // return new Promise((resolve) => {
      //   const webP = new Image();
      //   webP.src =
      //     "data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==";
      //   webP.onload = webP.onerror = function () {
      //     resolve(webP.height === 1);
      //     // resolve(false);
      //   };
      // });
      try {
        const canvas = document.createElement("canvas");
        if (canvas.getContext && canvas.getContext("2d")) {
          // 检查是否返回 true
          return (
            canvas.toDataURL("image/webp").indexOf("data:image/webp") === 0
          );
        }
        return false;
      } catch (e) {
        return false;
      }
    },
    /**
     * 修改获取图片路径的方法
     */
    getImagePath(imageName) {
      // 如果文件名已经包含扩展名，先移除
      const baseName = imageName.replace(/\.(webp|png)$/, "");
      if (this.supportsWebp) {
        console.log("getImagePath1:", baseName);
        return require(`./assets/images/gesture/${baseName}.webp`);
      } else {
        console.log("getImagePath2:", baseName);
        return require(`./assets/images/gesturepng/${baseName}.png`);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="less">
.key-con {
  width: 800px;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.gesture {
  display: block;
  left: 50%;
  transform: translateX(-50%);
  top: -25px;
  height: 350px;
  position: absolute;
  width: 1200px;
  pointer-events: none;
  user-select: none;

  div[class*="gesture"] {
    position: absolute;
    width: 630px;
    height: 650px;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .right_gesture {
    top: -10px;
    right: 106px;
  }
  .left_gesture {
    top: -34px;
    left: 10px;
  }
  .right_top_row {
    top: 0px;
    right: 94px;
  }
  .special_right {
    right: 60px;
    top: -10px;
  }

  .right_bottom_row {
    // top: 16px;
    right: 74px;
  }
}
.key-setting {
  position: absolute;
  user-select: none;
  -webkit-touch-callout: none !important; //华为浏览器兼容
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
input {
  width: 100%;
  height: 100px;
  padding: 20px;
  font-size: 20px;
  border: none;
  box-sizing: border-box;
}

.keyboardContainer {
  left: 50%;
  transform: translateX(-50%);
  top: 0;
  position: absolute;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  border-radius: 5px;
}

.simple-keyboard.hg-theme-default {
  display: inline-block;
}

.simple-keyboard-main.simple-keyboard {
  width: 100%;
}

.simple-keyboard-main.simple-keyboard .hg-row:first-child {
  margin-bottom: 2px;
  // margin-top: 25px;
}
.simple-keyboard-main.simple-keyboard .hg-row {
  margin-bottom: 2px;
  position: relative;
}

.simple-keyboard-arrows.simple-keyboard {
  align-self: flex-end;
  background: none;
}

.simple-keyboard .hg-button.selectedButton {
  background: rgba(5, 25, 70, 0.53);
  color: white;
}

.simple-keyboard .hg-button.emptySpace {
  pointer-events: none;
  background: none;
  border: none;
  box-shadow: none;
}

.simple-keyboard-arrows .hg-row {
  justify-content: center;
}

.simple-keyboard.hg-theme-default .hg-button {
  width: 50px;
  height: 50px;
  /* text-transform: uppercase; */
  font-family: museo-sans-rounded, sans-serif;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}
.simple-keyboard-arrows .hg-button {
  width: 50px;
  flex-grow: 0;
  justify-content: center;
  display: flex;
  align-items: center;
}

.controlArrows {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-flow: column;
}

.simple-keyboard-control.simple-keyboard {
  background: none;
}

.simple-keyboard-control.simple-keyboard .hg-row:first-child {
  margin-bottom: 10px;
}

.simple-keyboard-control .hg-button {
  width: 50px;
  flex-grow: 0;
  justify-content: center;
  display: flex;
  align-items: center;
}

.numPad {
  display: flex;
  align-items: flex-end;
}

.simple-keyboard-numpad.simple-keyboard {
  background: none;
}

.simple-keyboard-numpad.simple-keyboard {
  width: 160px;
}

.simple-keyboard-numpad.simple-keyboard .hg-button {
  width: 50px;
  justify-content: center;
  display: flex;
  align-items: center;
}

.simple-keyboard-numpadEnd.simple-keyboard {
  width: 50px;
  background: none;
  margin: 0;
  padding: 5px 5px 5px 0;
}

.simple-keyboard-numpadEnd.simple-keyboard .hg-button {
  align-items: center;
  justify-content: center;
  display: flex;
}

.simple-keyboard-numpadEnd .hg-button.hg-standardBtn.hg-button-plus {
  height: 85px;
}

.simple-keyboard-numpadEnd.simple-keyboard .hg-button.hg-button-enter {
  height: 85px;
}

.simple-keyboard.hg-theme-default .hg-button.hg-selectedButton {
  background: rgba(5, 25, 70, 0.53);
  color: white;
}

.key-group .up_ {
  /* line-height: 50%; */
  margin-top: -10px;
  font-size: 14px;
}
.key-group .up {
  /* line-height: 50%; */
  line-height: 95%;
  font-size: 14px;
  margin-top: 3px;
}
.key-group .down {
  /* line-height: 50%; */
  line-height: 95%;
  margin-top: 6px;
}

.keyboard-mac .simple-keyboard.hg-theme-default {
  .hg-button-tab {
    width: 80px;
  }
  .hg-button-capslock {
    width: 95px;
  }
  .hg-button-shiftleft {
    width: 120px;
  }
  .hg-button-arrowdown {
    height: 25px;
    position: absolute;
    right: 50px;
    bottom: -2px;
  }
  .hg-button-arrowup {
    height: 25px;
  }
  .hg-button-backspace {
    width: 80px;
  }
  .hg-button-arrowup,
  .hg-button-arrowdown,
  .hg-button-arrowleft,
  .hg-button-arrowright {
    font-weight: 900;
  }
  .hg-button-metaright,
  .hg-button-metaleft,
  .hg-button-fn,
  .hg-button-controlleft,
  .hg-button-altleft,
  .hg-button-altright,
  .hg-button-controlleft,
  .hg-button-fn,
  .hg-button-backspace,
  .hg-button-enter,
  .hg-button-tab,
  .hg-button-shiftleft,
  .hg-button-shiftright,
  .hg-button-capslock {
    padding-top: 28px;
    font-size: 14px;
    /* text-align: start; */
    align-items: left;
    justify-content: left;
    padding-left: 6px;
    user-select: none;
    -webkit-touch-callout: none !important; //华为浏览器兼容
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
  .hg-button-enter {
    width: 90px;
    padding-left: 30px;
  }
  .hg-button-shiftright {
    width: 120px;
    padding-left: 54px;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
  .hg-button-metaright,
  .hg-button-metaleft {
    width: 70px;
  }
  .hg-button-fn,
  .hg-button-controlleft,
  .hg-button-altleft,
  .hg-button-altright {
    width: 48px;
  }
  .hg-button-space {
    width: 282px;
  }

  .hg-button-metaright {
    padding-left: 30px;
  }
  .hg-button-altright {
    padding-left: 20px;
  }
}

@media screen and (max-width: 500px) and (orientation: portrait) {
  @scale-ratio: 1;

  .keyboard-mac .simple-keyboard.hg-theme-default {
    .hg-button-arrowdown {
      height: 25px * @scale-ratio;
      right: 45.76px * @scale-ratio;
    }
  }
}

// 移动端横屏适配，尺寸是原来的80% 竖屏
@media screen and (max-width: 1023px) and (orientation: landscape) {
  @scale-ratio: 1; // 可调节的缩放系数

  .key-con {
    width: 800px * @scale-ratio;
  }

  .gesture {
    width: 1200px * @scale-ratio;
    height: 350px * @scale-ratio;

    div[class$="_gesture"] {
      width: 630px * @scale-ratio;
      height: 650px * @scale-ratio;
    }
    .right_gesture {
      top: -10px * @scale-ratio;
      right: 106px * @scale-ratio;
    }
    .special_right {
      top: 0px * @scale-ratio;
      right: 70px * @scale-ratio;
    }
    .right_bottom_row {
      // top: 2px * @scale-ratio;
      right: 88px * @scale-ratio;
    }
  }

  .simple-keyboard-main.simple-keyboard {
    width: 100%;
    max-width: 800px * @scale-ratio;

    .hg-row:first-child {
      // margin-top: 25px * @scale-ratio;
    }
  }

  .simple-keyboard.hg-theme-default .hg-button {
    width: 50px * @scale-ratio;
    height: 50px * @scale-ratio;
    font-size: 12px;
  }

  .keyboard-mac .simple-keyboard.hg-theme-default {
    .hg-button-tab {
      width: 80px * @scale-ratio;
    }
    .hg-button-capslock {
      width: 95px * @scale-ratio;
    }
    .hg-button-shiftleft {
      width: 120px * @scale-ratio;
    }
    .hg-button-space {
      width: 282px * @scale-ratio;
    }
    .hg-button-enter {
      width: 90px * @scale-ratio;
    }
    .hg-button-shiftright {
      width: 120px * @scale-ratio;
      padding-left: 70px * @scale-ratio;
    }
    .hg-button-metaright,
    .hg-button-metaleft {
      width: 70px * @scale-ratio;
    }
    .hg-button-fn,
    .hg-button-controlleft,
    .hg-button-altleft,
    .hg-button-altright {
      width: 48px * @scale-ratio;
    }

    // 调整功能键的文字位置
    .hg-button-metaright,
    .hg-button-metaleft,
    .hg-button-fn,
    .hg-button-controlleft,
    .hg-button-altleft,
    .hg-button-altright,
    .hg-button-controlleft,
    .hg-button-fn,
    .hg-button-backspace,
    .hg-button-enter,
    .hg-button-tab,
    .hg-button-shiftleft,
    .hg-button-shiftright,
    .hg-button-capslock {
      padding-top: 7px;
      padding-left: 6px * @scale-ratio;
    }

    .hg-button-arrowdown {
      height: 25px * @scale-ratio;
      right: 47px * @scale-ratio;
    }
    .hg-button-arrowup {
      height: 25px * @scale-ratio;
    }
  }
}
</style>
